
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import ImpfDbLog from '@/types/ImpfDbLog';
    import { VMenu } from '@/types/Components';
    import { WavmOptions } from '@/store/statistik';

    @Component({
        computed: {
            ...mapState('statistik', ['loaders', 'wavmLogs']),
        },
        methods: {
            ...mapActions('statistik', ['exportWavm', 'previewWavm', 'repeatWavm', 'loadWavmLogs']),
        },
    })
    export default class WavmDialog extends Vue {
        @Prop() public visible!: boolean;

        public $refs!: {
            zeitraumMenu: VMenu;
        };

        public wavmLogs!: ImpfDbLog[];
        public loadWavmLogs!: () => void;
        public exportWavm!: (payload: { options: WavmOptions }) => void;
        public repeatWavm!: (payload: { options: WavmOptions }) => void;
        public previewWavm!: (payload: { options: WavmOptions }) => void;

        public zeitraumMenu = false;

        public options: WavmOptions = {
            zeitraum: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            alle: false,
        };

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.loadWavmLogs();
            }
        }

        public get latestLog(): ImpfDbLog {
            const [log] = this.wavmLogs;
            return log;
        }

        public get canPrint(): boolean {
            return this.options.zeitraum.length === 2;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get maxJahrgang(): number {
            return moment().year();
        }

        public get zeitraumLabel(): string {
            return this.options.zeitraum.length
                ? 'von ' + this.options.zeitraum.sort((a, b) => a.localeCompare(b)).map((date) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' bis ')
                : '';
        }

        @Watch('zeitraum')
        public onChangeZeitraum(dates: [string, string]): void {
            if (dates?.length === 2) {
                this.options.zeitraum = dates;
            }
        }

        public saveZeitraum(date: [string, string]): void {
            this.options.zeitraum = date;
            this.$refs.zeitraumMenu.save(date);
        }

        public onClickExport(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.exportWavm({ options });
        }

        public onClickRepeat(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.repeatWavm({ options });
        }

        public onClickPreview(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.previewWavm({ options });
        }
    }
